// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 957 ? "views-app" : chunkId) + "." + {"453":"a04ae9d0","454":"1dc66ca6","512":"cf568f9e","957":"bdbd0bb1","993":"786837da"}[chunkId] + ".chunk.js";
};